require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.regexp.split");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./shadow.js.shim.module$$nivo$bar.js");

require("./shadow.js.shim.module$$nivo$line.js");

require("./clojure.string.js");

require("./com.wsscode.blog.components.ui.js");

require("./helix.core.js");

require("./helix.dom.js");

require("./helix.hooks.js");

require("./promesa.core.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("com.wsscode.blog.components.charts.js");
goog.provide('com.wsscode.blog.components.charts');

com.wsscode.blog.components.charts.component_factory = function com$wsscode$blog$components$charts$component_factory(component) {
  return function com$wsscode$blog$components$charts$component_factory_$_factory_constructor(props) {
    var G__24236 = component;
    var G__24237 = cljs.core.clj__GT_js(props);
    return helix.core.create_element.cljs$core$IFn$_invoke$arity$2 ? helix.core.create_element.cljs$core$IFn$_invoke$arity$2(G__24236, G__24237) : helix.core.create_element.call(null, G__24236, G__24237);
  };
};

com.wsscode.blog.components.charts.line_chart = com.wsscode.blog.components.charts.component_factory(shadow.js.shim.module$$nivo$line.ResponsiveLine);
goog.exportSymbol('com.wsscode.blog.components.charts.line_chart', com.wsscode.blog.components.charts.line_chart);
com.wsscode.blog.components.charts.bar_chart = com.wsscode.blog.components.charts.component_factory(shadow.js.shim.module$$nivo$bar.ResponsiveBar);
goog.exportSymbol('com.wsscode.blog.components.charts.bar_chart', com.wsscode.blog.components.charts.bar_chart);
com.wsscode.blog.components.charts.extension__GT_type = new cljs.core.PersistentArrayMap(null, 1, ["puml", "plantuml"], null);

com.wsscode.blog.components.charts.path_extension = function com$wsscode$blog$components$charts$path_extension(path) {
  return cljs.core.last(clojure.string.split.cljs$core$IFn$_invoke$arity$2(path, "."));
};

com.wsscode.blog.components.charts.request_graph = function com$wsscode$blog$components$charts$request_graph(graph_type, source) {
  return promesa.protocols._bind(promesa.protocols._promise(null), function (___23891__auto__) {
    return promesa.protocols._bind(promesa.protocols._promise(fetch(["https://kroki.io/", cljs.core.str.cljs$core$IFn$_invoke$arity$1(graph_type), "/svg"].join(''), {
      "method": "post",
      "headers": {
        "Content-Type": "text/plain"
      },
      "body": source
    })), function (response) {
      return promesa.protocols._bind(promesa.protocols._promise(null), function (___23875__auto__) {
        return promesa.protocols._promise(response.text());
      });
    });
  });
};

com.wsscode.blog.components.charts.use_kroki_diagram = function com$wsscode$blog$components$charts$use_kroki_diagram(p__24239) {
  var map__24240 = p__24239;
  var map__24240__$1 = (!(map__24240 == null) ? map__24240.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__24240.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__24240) : map__24240;
  var type = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24240__$1, new cljs.core.Keyword(null, "type", "type", 1174270348));
  var source = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24240__$1, new cljs.core.Keyword(null, "source", "source", -433931539));
  var vec__24242 = helix.hooks.use_state(null);
  var diagram_svg = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24242, 0, null);
  var ds_BANG_ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24242, 1, null);
  var G__24248_24409 = helix.hooks.wrap_fx(function () {
    if (cljs.core.truth_(function () {
      var and__4115__auto__ = type;

      if (cljs.core.truth_(and__4115__auto__)) {
        return source;
      } else {
        return and__4115__auto__;
      }
    }())) {
      return promesa.core.then.cljs$core$IFn$_invoke$arity$2(com.wsscode.blog.components.charts.request_graph(type, source), ds_BANG_);
    } else {
      return null;
    }
  });
  var G__24249_24410 = [type, source];
  helix.hooks.raw_use_effect.cljs$core$IFn$_invoke$arity$2 ? helix.hooks.raw_use_effect.cljs$core$IFn$_invoke$arity$2(G__24248_24409, G__24249_24410) : helix.hooks.raw_use_effect.call(null, G__24248_24409, G__24249_24410);
  return diagram_svg;
};

com.wsscode.blog.components.charts.KrokiDiagram = function () {
  var G__24257 = function com$wsscode$blog$components$charts$KrokiDiagram_render(props__21282__auto__, maybe_ref__21283__auto__) {
    var vec__24258 = new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [helix.core.extract_cljs_props(props__21282__auto__), maybe_ref__21283__auto__], null);
    var diagram = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24258, 0, null);
    var diagram_svg = com.wsscode.blog.components.charts.use_kroki_diagram(diagram);

    if (cljs.core.truth_(diagram_svg)) {
      return helix.core.get_react().createElement("div", function () {
        var obj24262 = {
          "className": "kroki-container",
          "dangerouslySetInnerHTML": {
            "__html": diagram_svg
          }
        };
        return obj24262;
      }());
    } else {
      return helix.core.get_react().createElement("noscript", null);
    }
  };

  if (goog.DEBUG === true) {
    var G__24263 = G__24257;
    G__24263.displayName = "com.wsscode.blog.components.charts/KrokiDiagram";
    return G__24263;
  } else {
    return G__24257;
  }
}();

goog.exportSymbol('com.wsscode.blog.components.charts.KrokiDiagram', com.wsscode.blog.components.charts.KrokiDiagram);

com.wsscode.blog.components.charts.use_diagram_file = function com$wsscode$blog$components$charts$use_diagram_file(path) {
  var vec__24265 = helix.hooks.use_state(new cljs.core.Keyword("com.wsscode.blog.components.ui", "loading", "com.wsscode.blog.components.ui/loading", -911961282));
  var contents = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24265, 0, null);
  var c_BANG_ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24265, 1, null);
  var G__24268_24411 = helix.hooks.wrap_fx(function () {
    var type = function () {
      var G__24270 = com.wsscode.blog.components.charts.path_extension(path);
      return com.wsscode.blog.components.charts.extension__GT_type.cljs$core$IFn$_invoke$arity$1 ? com.wsscode.blog.components.charts.extension__GT_type.cljs$core$IFn$_invoke$arity$1(G__24270) : com.wsscode.blog.components.charts.extension__GT_type.call(null, G__24270);
    }();

    return promesa.core.catch$.cljs$core$IFn$_invoke$arity$2(promesa.protocols._bind(promesa.protocols._promise(null), function (___23891__auto__) {
      return promesa.protocols._bind(promesa.protocols._promise(fetch(path)), function (res) {
        return promesa.protocols._bind(promesa.protocols._promise(res.text()), function (txt) {
          return promesa.protocols._bind(promesa.protocols._promise(null), function (___23875__auto__) {
            return promesa.protocols._promise(function () {
              var G__24271 = new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "type", "type", 1174270348), type, new cljs.core.Keyword(null, "source", "source", -433931539), txt], null);
              return c_BANG_.cljs$core$IFn$_invoke$arity$1 ? c_BANG_.cljs$core$IFn$_invoke$arity$1(G__24271) : c_BANG_.call(null, G__24271);
            }());
          });
        });
      });
    }), function (p1__24264_SHARP_) {
      var G__24272 = new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.wsscode.blog.components.ui", "error", "com.wsscode.blog.components.ui/error", -887676017), p1__24264_SHARP_], null);
      return c_BANG_.cljs$core$IFn$_invoke$arity$1 ? c_BANG_.cljs$core$IFn$_invoke$arity$1(G__24272) : c_BANG_.call(null, G__24272);
    });
  });
  var G__24269_24412 = [path];
  helix.hooks.raw_use_effect.cljs$core$IFn$_invoke$arity$2 ? helix.hooks.raw_use_effect.cljs$core$IFn$_invoke$arity$2(G__24268_24411, G__24269_24412) : helix.hooks.raw_use_effect.call(null, G__24268_24411, G__24269_24412);
  return contents;
};

com.wsscode.blog.components.charts.KrokiDiagramFile = function () {
  var G__24274 = function com$wsscode$blog$components$charts$KrokiDiagramFile_render(props__21282__auto__, maybe_ref__21283__auto__) {
    var vec__24275 = new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [helix.core.extract_cljs_props(props__21282__auto__), maybe_ref__21283__auto__], null);
    var map__24278 = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24275, 0, null);
    var map__24278__$1 = (!(map__24278 == null) ? map__24278.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__24278.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__24278) : map__24278;
    var path = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24278__$1, new cljs.core.Keyword(null, "path", "path", -188191168));
    var diagram_data = com.wsscode.blog.components.charts.use_diagram_file(path);
    return com.wsscode.blog.components.ui.loader(diagram_data, function (diagram) {
      return helix.core.get_react().createElement(com.wsscode.blog.components.charts.KrokiDiagram, helix.impl.props.merge_obj({}, helix.impl.props._props.cljs$core$IFn$_invoke$arity$1(diagram)));
    });
  };

  if (goog.DEBUG === true) {
    var G__24402 = G__24274;
    G__24402.displayName = "com.wsscode.blog.components.charts/KrokiDiagramFile";
    return G__24402;
  } else {
    return G__24274;
  }
}();

goog.exportSymbol('com.wsscode.blog.components.charts.KrokiDiagramFile', com.wsscode.blog.components.charts.KrokiDiagramFile);
Object.defineProperty(module.exports, "extension__GT_type", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.components.charts.extension__GT_type;
  }
});
Object.defineProperty(module.exports, "KrokiDiagramFile", {
  enumerable: true,
  get: function get() {
    return com.wsscode.blog.components.charts.KrokiDiagramFile;
  }
});
Object.defineProperty(module.exports, "line_chart", {
  enumerable: true,
  get: function get() {
    return com.wsscode.blog.components.charts.line_chart;
  }
});
Object.defineProperty(module.exports, "use_diagram_file", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.components.charts.use_diagram_file;
  }
});
Object.defineProperty(module.exports, "KrokiDiagram", {
  enumerable: true,
  get: function get() {
    return com.wsscode.blog.components.charts.KrokiDiagram;
  }
});
Object.defineProperty(module.exports, "bar_chart", {
  enumerable: true,
  get: function get() {
    return com.wsscode.blog.components.charts.bar_chart;
  }
});
Object.defineProperty(module.exports, "component_factory", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.components.charts.component_factory;
  }
});
Object.defineProperty(module.exports, "request_graph", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.components.charts.request_graph;
  }
});
Object.defineProperty(module.exports, "use_kroki_diagram", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.components.charts.use_kroki_diagram;
  }
});
Object.defineProperty(module.exports, "path_extension", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.components.charts.path_extension;
  }
});